import { AddOneTimeAssignmentController } from './add-one-time-assignment.controller';
import { AddOneTimeAssignmentProps } from './add-one-time-assignment.model';

const AddOneTimeAssignment = (props: AddOneTimeAssignmentProps) => {
  return <AddOneTimeAssignmentController {...props} />;
};

export default AddOneTimeAssignment;
